import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';


import CdrScraperStatsBadge from './CdrScraperStatsBadge';

export default function CdrScraper(props) {

    let didInit = false;
    const [brands, setBrands] = React.useState([]);
    const [updateAll,setUpdateAll] = React.useState(false);
    
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setUpdateAll(event.target.checked);
    };




    React.useEffect(() => {
      if (!didInit) {
        didInit = true;
        fetch('/api/cdr/allBrandStats', { cache: 'no-store' })
          .then((res) => res.json())
          .then((data) => {
            setBrands([...data]);
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    }, [props.scrapeStatus]);

    function runScraper(brand) {

        console.log('props.API_REFRESH_INTERVAL ' + props.API_REFRESH_INTERVAL);

      fetch('/api/cdr/latestSummaryBrand', {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ brand: brand, updateAll: updateAll}),
      }).then(
        (response) => {
          
        },
        (error) => {
          console.log(error);
        }
      ); // Displaying the stringified data in an alert popup

      props.getScraperStatus().then((status) => {
        console.log('getScraperStatus: ' + status);

        props.handleScrapeStatusChange(status);
      });
      props.handleSetDelay(props.API_REFRESH_INTERVAL);
    }


    function runScraperAll() {
      console.log('props.API_REFRESH_INTERVAL ' + props.API_REFRESH_INTERVAL);

      fetch('/api/cdr/process', {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ method: 'manual', updateAll: updateAll }),
      }).then(
        (response) => {},
        (error) => {
          console.log(error);
        }
      ); // Displaying the stringified data in an alert popup

      props.getScraperStatus().then((status) => {
        console.log('getScraperStatus: ' + status);

        props.handleScrapeStatusChange(status);
      });
      props.handleSetDelay(props.API_REFRESH_INTERVAL);
    }

    function refreshBrands() {
      fetch('/api/cdr/allBrandStats', { cache: 'no-store' })
        .then((res) => res.json())
        .then((data) => {
          setBrands([...data]);
        })
        .catch((err) => {
          console.log(err.message);
        });
    }

    function sourceBaseUrl(brand) {
      return brand.publicBaseUri_override || brand.publicBaseUri;
    }

    function formatDate(value) {
      if (!value) return '';
      return new Date(value).toLocaleString();
    }

    function updateBrandSource(brand, action) {
      fetch('/api/cdr/brandSource/' + action, {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          brandId: brand._id,
          reason: 'manual ' + action + ' from plan scraper admin',
        }),
      }).then(
        () => refreshBrands(),
        (error) => {
          console.log(error);
        }
      );
    }

    return (
      <Box>
        <Grid container spacing={1}>
          <Grid item xs={8}>
            <h3>CDR Brands</h3>
          </Grid>
          <Grid item xs={2}>
            <Button
              variant='outlined'
              disabled={props.scrapeStatus !== 'READY'}
              onClick={() => runScraperAll()}
            >
              Run All{' '}
              {props.scrapeStatus !== 'READY' ? <CircularProgress /> : ''}
            </Button>
          </Grid>
          <Grid item xs={2}>
            <FormGroup>
              <FormControlLabel
                control={<Switch checked={updateAll} onChange={handleChange} />}
                label='Update All Plans'
              />
            </FormGroup>
          </Grid>
        </Grid>

        {brands && (
          <TableContainer>
            <Table size='small' aria-label='CDR retailers and recent scrape statistics'>
              <TableBody>
                {brands.map((b) => (
                  <TableRow key={b.brand._id || b.brand.brandName}>
                    <TableCell component='th' scope='row' sx={{ width: '18%', py: 2 }}>{b.brand.brandName}</TableCell>
                    <TableCell sx={{ overflowWrap: 'anywhere' }}>
                      {sourceBaseUrl(b.brand)}
                      <Box component='details' sx={{ mt: 1, fontSize: '0.8rem' }}>
                        <Box component='summary' sx={{ cursor: 'pointer', color: 'text.secondary' }}>
                          Source details · {b.brand.sourceStatus || 'active'}
                          {b.brand.scrapeEnabled === false ? ' · disabled' : ''}
                          {b.brand.consecutivePlanListFailures ? ` · ${b.brand.consecutivePlanListFailures} failures` : ''}
                        </Box>
                        <Box sx={{ py: 1 }}>
                          <div>{b.brand.sourceStatusReason}</div>
                          <div>Last register seen: {formatDate(b.brand.lastSeenInRegisterAt)}</div>
                          <div>Last plan list: {formatDate(b.brand.lastSuccessfulPlanListAt)}</div>
                          <div>Plans: {b.brand.lastPlanCount ?? '—'}</div>
                          <div>Failures: {b.brand.consecutivePlanListFailures || 0}</div>
                          <div>{b.brand.lastFailureMessage}</div>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', pb: 1 }}>

                      {(b.brand.sourceStatus === 'disabled' ||
                        b.brand.sourceStatus === 'retired' ||
                        b.brand.scrapeEnabled === false) && (
                        <Button
                          variant='outlined'
                          size='small'
                          onClick={() => updateBrandSource(b.brand, 'enable')}
                        >
                          Enable
                        </Button>
                      )}
                      {b.brand.sourceStatus !== 'disabled' &&
                        b.brand.scrapeEnabled !== false && (
                          <Button
                            variant='outlined'
                            size='small'
                            onClick={() =>
                              updateBrandSource(b.brand, 'disable')
                            }
                          >
                            Disable
                          </Button>
                        )}
                      {b.brand.sourceStatus !== 'retired' && (
                        <Button
                          variant='outlined'
                          size='small'
                          onClick={() => updateBrandSource(b.brand, 'retire')}
                        >
                          Retire
                        </Button>
                      )}


                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant='outlined'
                        disabled={
                          props.scrapeStatus !== 'READY' ||
                          !sourceBaseUrl(b.brand) ||
                          b.brand.scrapeEnabled === false ||
                          b.brand.sourceStatus === 'retired' ||
                          b.brand.sourceStatus === 'disabled'
                        }
                        onClick={() => runScraper(b.brand)}
                      >
                        Run{' '}
                        {props.scrapeStatus !== 'READY' ? (
                          <CircularProgress />
                        ) : (
                          ''
                        )}
                      </Button>
                    </TableCell>
                    <TableCell>
                      <CdrScraperStatsBadge stats={b.stats}>
                        {' '}
                      </CdrScraperStatsBadge>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    );
}
